export const FEATURE_OFF = 'FALSE';
export const FEATURE_ENABLED_FOR_EVEN_IDS = 'EVEN';
export const FEATURE_ENABLED_FOR_ODD_IDS = 'ODD';
export const FEATURE_ENABLED_FOR_EVERYONE = 'TRUE';
